import { RouteObject } from 'react-router-dom';
import { AccessLevelManagement } from './views/AccessLevelManagement';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';

export const accessLevelRoutes: RouteObject[] = [
    {
        path: '/admin/nub/access-levels',
        element: <AccessLevelManagement />,
        errorElement: <ErrorBoundary />,
    }
];